import request from '@/utils/request'

export function getallApi(params) {
  return request({
    url: '?c=fam&a=tag&do=getall',
    method: 'get',
    params
  })
}

export function postApi(data) {
  return request({
    url: '?c=fam&a=tag&do=post',
    method: 'post',
    data
  })
}

export function deleteApi(data) {
  return request({
    url: '?c=fam&a=tag&do=delete',
    method: 'post',
    data
  })
}

export function sortApi(data) {
  return request({
    url: '?c=fam&a=tag&do=sort',
    method: 'post',
    data
  })
}

export function fetchApi(params) {
  return request({
    url: '?c=fam&a=tag&do=fetch',
    method: 'get',
    params
  })
}

export function setApi(data) {
  return request({
    url: '?c=fam&a=tag&do=set',
    method: 'post',
    data
  })
}
